var React = require('react');

function EnvelopeWhite (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M464,64H48C21.5,64,0,85.5,0,112v288c0,26.5,21.5,48,48,48h416c26.5,0,48-21.5,48-48V112\n\tC512,85.5,490.5,64,464,64z M464,96c2.2,0,4.2,0.5,6.1,1.2L256,282.8L41.9,97.2c1.9-0.8,4-1.2,6.1-1.2L464,96z M464,416H48\n\tc-8.8,0-16-7.2-16-16V131l213.5,185c3,2.6,6.8,3.9,10.5,3.9s7.5-1.3,10.5-3.9L480,131v269C480,408.8,472.8,416,464,416z","key":1})]);
}

EnvelopeWhite.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = EnvelopeWhite;

EnvelopeWhite.default = EnvelopeWhite;
